import { MeetingPlatformType } from '@/types';

export const MeetingPlatformTypeNameMap = {
    [MeetingPlatformType.GOOGLE_MEET]: 'Google Meet',
    [MeetingPlatformType.ZOOM]: 'Zoom',
    [MeetingPlatformType.MICROSOFT_TEAMS]: 'Microsoft Teams',
    [MeetingPlatformType.WEBEX]: 'Webex',
    [MeetingPlatformType.BLUEJEANS]: 'BlueJeans',
};
